import xlsx from 'xlsx';
import { Channel_CODE_SET, Section_CODE_SET } from '../../../config/CgmCodeSet';
import { TREND_DETAIL_AGE_GENDER_SET, TREND_DETAIL_CUSTOM_AGE_SET, TREND_DETAIL_CUSTOM_GENDER_SET } from '../../../config/TrendDetailAgeGenderSet';

const arrayCompare = (arr1, arr2) => {
  for (let i = 0; i < arr1.length || i < arr2.length; i++) {
    if (arr1[i] !== arr2[i]) {
      return false;
    }
    else {
      continue;
    }
  }
  return true;
}

const toJavaScriptString = (jsonString) => {
  var result = jsonString.replace(/\\n/g, "\\n")
    .replace(/\\'/g, "\\'")
    .replace(/\\"/g, '\\"')
    .replace(/\\&/g, "\\&")
    .replace(/\\r/g, "\\r")
    .replace(/\\t/g, "\\t")
    .replace(/\\b/g, "\\b")
    .replace(/\\f/g, "\\f");

  result = result.replace(/[\u0000-\u0019]+/g, "");

  return result;
}

function replaceMultipleCharacters(str, targets, replacement) {
  const escapedTargets = targets.map(target =>
    target.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
  );

  const regex = new RegExp(escapedTargets.join('|'), 'g');

  return str.replaceAll(regex, replacement);
}

function splitString(str) {
  const match = str.match(/(\D+)(\d+)/);
  if (match) {

    return [match[1], match[2]];
  }
  return null; // 형식이 맞지 않는 경우
}

const setQueryExcelData = (queryLabelData) => {
  let retDataSet = [];
  queryLabelData.info.forEach((label) => {
    if (label.checked) {
      label.labelItem.forEach((queryItem) => {
        if (queryItem.QUERY_TYPE == 'BOOLEAN') {
          let pushItem = {
            "ID": queryItem.queryID,
            "Label": label.name,
            "Name": queryItem.name,
            "Type": queryItem.QUERY_TYPE,
            "Boolean": JSON.parse(toJavaScriptString(queryItem.content)).boolQuery,
            "Basic(AND)": "",
            "Basic(OR)": "",
            "Basic(NOT)": ""
          }
          retDataSet.push(pushItem);
        }
        else if (queryItem.QUERY_TYPE == 'BASIC') {
          let pushItem = {
            "ID": queryItem.queryID,
            "Label": label.name,
            "Name": queryItem.name,
            "Type": queryItem.QUERY_TYPE,
            "Boolean": "",
            "Basic(AND)": JSON.parse(toJavaScriptString(queryItem.content)).and.join(', '),
            "Basic(OR)": JSON.parse(toJavaScriptString(queryItem.content)).or.join(', '),
            "Basic(NOT)": JSON.parse(toJavaScriptString(queryItem.content)).not.join(', ')
          }
          retDataSet.push(pushItem);
        }
      })
    }
  })

  queryLabelData.nullLabelItem.forEach((queryItem) => {
    if (queryItem.checked) {
      if (queryItem.QUERY_TYPE == 'BOOLEAN') {
        let pushItem = {
          "ID": queryItem.queryID,
          "Label": "",
          "Name": queryItem.name,
          "Type": queryItem.QUERY_TYPE,
          "Boolean": JSON.parse(toJavaScriptString(queryItem.content)).boolQuery,
          "Basic(AND)": "",
          "Basic(OR)": "",
          "Basic(NOT)": ""
        }
        retDataSet.push(pushItem);
      }
      else if (queryItem.QUERY_TYPE == 'BASIC') {
        let pushItem = {
          "ID": queryItem.queryID,
          "Label": "",
          "Name": queryItem.name,
          "Type": queryItem.QUERY_TYPE,
          "Boolean": "",
          "Basic(AND)": JSON.parse(toJavaScriptString(queryItem.content)).and.join(', '),
          "Basic(OR)": JSON.parse(toJavaScriptString(queryItem.content)).or.join(', '),
          "Basic(NOT)": JSON.parse(toJavaScriptString(queryItem.content)).not.join(', ')
        }
        retDataSet.push(pushItem);
      }
    }
  })
  return retDataSet;
}

const setBuzzlistExcelData = (data, name, dateRange, reportType, subQueryType, role) => {
  if (role == 'ROLE_ADMIN') {
    let retDataSet = [
      ["Name", name],
      ["DateRange", dateRange],
      ["Report Type", reportType.toUpperCase()],
      ["Channel", Channel_CODE_SET[data.all.info.code]],
      ["Function", subQueryType.toUpperCase()],
      ["BaseKeyword", data.all.info.name.join(' & ')],
      [""],
      // ["psid", "title", "sentiment", "published", "author", "channel", "link", "source", "chid", "Search Result"]
      // only admin => psid, author, description
      //
      ["psid", "title", "published", "source", "channel", "link", "author", "description"]
    ];

    data.all.buzzlist.forEach(buzzRow => {
      if (buzzRow.description.length > 30000) {
        let description = buzzRow.description.substr(0, 30000);
        retDataSet.push([buzzRow.psid, buzzRow.title, buzzRow.published, Section_CODE_SET[buzzRow.cgmcode], buzzRow.channel, { f: `HYPERLINK("${buzzRow.title_link}")` }, buzzRow.author, description])
      }
      else {
        retDataSet.push([buzzRow.psid, buzzRow.title, buzzRow.published, Section_CODE_SET[buzzRow.cgmcode], buzzRow.channel, { f: `HYPERLINK("${buzzRow.title_link}")` }, buzzRow.author, buzzRow.description])
      }
      // retDataSet.push([buzzRow.psid, buzzRow.title, buzzRow.published, Channel_CODE_SET[data.all.info.code], buzzRow.title_link, buzzRow.author, buzzRow.description])
    })

    return retDataSet;
  }
  else if (role == 'ROLE_USER' || role == 'ROLE_USER_01' || role == 'ROLE_USER_02' || role == 'ROLE_USER_03' || role == 'ROLE_USER_04') {
    let retDataSet = [
      ["Name", name],
      ["DateRange", dateRange],
      ["Report Type", reportType.toUpperCase()],
      ["Channel", Channel_CODE_SET[data.all.info.code]],
      ["Function", subQueryType.toUpperCase()],
      ["BaseKeyword", data.all.info.name.join(' & ')],
      [""],
      // ["psid", "title", "sentiment", "published", "author", "channel", "link", "source", "chid", "Search Result"]
      // only admin => psid, author, description
      //
      ["title", "published", "source", "channel", "link"]
    ];

    data.all.buzzlist.forEach(buzzRow => {
      // retDataSet.push([buzzRow.psid, buzzRow.title, buzzRow.published, Channel_CODE_SET[data.all.info.code], buzzRow.title_link, buzzRow.author, buzzRow.description])
      retDataSet.push([buzzRow.title, buzzRow.published, Section_CODE_SET[buzzRow.cgmcode], buzzRow.channel, { f: `HYPERLINK("${buzzRow.title_link}")` }])
    })

    return retDataSet;
  }
  else return;
}

const setReportExcelData = (data) => {
  let retDataSet = [
    ["Name", data.name],
    ["DateRange", data.dateRange],
    ["Report Type", data.reportType.toUpperCase()],
    ["ReTweet"],
    ["Channel"], //push
    ["Function", data.subQueryType.toUpperCase()],
    ["BaseKeyword"]
  ];

  if (data.reTweet) {
    retDataSet[3].push("Included")
  }
  else {
    retDataSet[3].push("Exluded")
  }

  data.channels.forEach((item) => {
    retDataSet[4].push(Channel_CODE_SET[item])
  })

  retDataSet[6].push(`${data.mainQuery.name} (${data.mainQuery.type})`)

  switch (data.mainQuery.type) {
    case 'BOOLEAN': {
      retDataSet[6].push(data.mainQuery.content.boolQuery);
      break;
    }
    case 'BASIC': {
      retDataSet[6].push(data.mainQuery.content.and.join(', '));
      retDataSet[6].push(data.mainQuery.content.or.join(', '));
      retDataSet[6].push(data.mainQuery.content.not.join(', '));
      break;
    }
    default:
      break;
  }

  if (data.subQuery.length != 0) {
    data.subQuery.forEach((item, index) => {
      let pushSubQuery = [`SubKeyword ${index + 1}`];
      pushSubQuery.push(`${item.name} (${item.type})`);
      switch (item.type) {
        case 'BOOLEAN': {
          pushSubQuery.push(item.content.boolQuery);
          break;
        }
        case 'BASIC': {
          pushSubQuery.push(item.content.and.join(', '));
          pushSubQuery.push(item.content.or.join(', '));
          pushSubQuery.push(item.content.not.join(', '));
          break;
        }
        default:
          break;
      }

      retDataSet.push(pushSubQuery);
    })
  }
  retDataSet.push([""]);

  switch (data.reportType) {
    case "volume": {
      retDataSet.push(["Keyword"]);
      retDataSet.push(["Date"]);

      let dataStartIndex = retDataSet.length - 2;

      data.reportData[0].data.forEach((item) => {
        if (item.hasOwnProperty('end_date')) {
          retDataSet.push([`${item.date} ~ ${item.end_date}`]);
        }
        else {
          retDataSet.push([item.date]);
        }
      })

      data.reportData.forEach((reportItem) => {
        let queryName = reportItem.query.join(' & ');
        retDataSet[dataStartIndex].push(queryName);
        for (let l = 0; l < reportItem.channel.length - 1; l++) {
          retDataSet[dataStartIndex].push("");
        }

        reportItem.channel.forEach((channelItem) => {
          retDataSet[dataStartIndex + 1].push(Channel_CODE_SET[channelItem]);

          reportItem.data.forEach((item, index) => {
            retDataSet[dataStartIndex + 2 + index].push([item[channelItem]]);
          })
        })
      })

      break;
    }
    case "sentiment": {
      let queryList = [];
      data.reportData.forEach(item => {
        if (queryList.length == 0) {
          queryList.push(item.query);
        }
        else {
          queryList.some((query, index) => {
            if (arrayCompare(item.query, query)) {
              return true;
            }
            else {
              if (index == (queryList.length - 1)) {
                queryList.push(item.query)
              }
            }
          })
        }
      })

      queryList.forEach(query => {
        retDataSet.push(["Keyword", query.join(' & ')]);
        retDataSet.push(["Channel"]);
        let dataStartIndex = retDataSet.length - 1;

        retDataSet.push(["Date"]);
        data.reportData[0].data.forEach((item) => {
          if (item.hasOwnProperty('end_date')) {
            retDataSet.push([`${item.date} ~ ${item.end_date}`]);
          }
          else {
            retDataSet.push([item.date]);
          }
        })

        data.reportData.filter(reportItem => arrayCompare(reportItem.query, query)).forEach(filteredItem => {
          retDataSet[dataStartIndex].push(Channel_CODE_SET[filteredItem.channel], "", "", "", "", "");
          retDataSet[dataStartIndex + 1].push("긍정", "부정", "혼합", "중립", "긍정비율", "부정비율");
          filteredItem.data.forEach((row, index) => {
            let sumFreq = row.positive + row.negative + row.mix + row.neutral;
            if (sumFreq == 0) {
              retDataSet[dataStartIndex + 2 + index].push(row.positive, row.negative, row.mix, row.neutral,
                'N/A', 'N/A')
            }
            else {
              retDataSet[dataStartIndex + 2 + index].push(row.positive, row.negative, row.mix, row.neutral,
                `${Math.round((row.positive / sumFreq) * 10000) / 100}%`, `${Math.round((row.negative / sumFreq) * 10000) / 100}%`)
            }
          })
        })
      })
      break;
    }
    case "source": {
      let queryList = [];
      data.reportData.forEach(item => {
        if (queryList.length == 0) {
          queryList.push(item.info.query);
        }
        else {
          queryList.some((query, index) => {
            if (arrayCompare(item.info.query, query)) {
              return true;
            }
            else {
              if (index == (queryList.length - 1)) {
                queryList.push(item.info.query)
              }
            }
          })
        }
      })

      queryList.forEach(query => {
        retDataSet.push(["Keyword", query.join(' & ')]);
        retDataSet.push(["Channel"]);
        let dataStartIndex = retDataSet.length - 1;

        retDataSet.push(["Rank", "Title", "Link", "Media", "Volume"])
        data.reportData.filter(reportItem => arrayCompare(reportItem.info.query, query)).forEach(filteredItem => {
          retDataSet[dataStartIndex].push(Channel_CODE_SET[filteredItem.info.channel], "", "", "");
          filteredItem.content.some((item, index) => {
            retDataSet.push([index + 1, item.title, { f: `HYPERLINK("${item.link}")` }, Channel_CODE_SET[filteredItem.info.channel], item.frequency])
          })
        })
        // retDataSet.push(["Keyword", query.join(' & ')]);
        // retDataSet.push(["Channel"]);
        // let dataStartIndex = retDataSet.length-1;

        // retDataSet.push(["Rank"])
        // for (let i = 1; i<=50; i++){
        //   retDataSet.push([i]);
        // }

        // data.reportData.filter(reportItem=>arrayCompare(reportItem.info.query, query)).forEach(filteredItem=>{
        //   retDataSet[dataStartIndex].push(Channel_CODE_SET[filteredItem.info.channel], "", "", "");
        //   retDataSet[dataStartIndex+1].push("Title", "Link", "Media", "Volume") 

        //   filteredItem.content.some((item,index)=>{
        //     if(index == 50){
        //       return true;
        //     }
        //     else{
        //       retDataSet[dataStartIndex+2+index].push(item.title, {f:`HYPERLINK("${item.link}")`}, Channel_CODE_SET[filteredItem.info.channel], item.frequency)
        //     }
        //   })
        // })
      })
      break;
    }
    case "category": {
      let queryList = [];
      data.reportData.forEach(item => {
        if (queryList.length == 0) {
          queryList.push(item.query);
        }
        else {
          queryList.some((query, index) => {
            if (arrayCompare(item.query, query)) {
              return true;
            }
            else {
              if (index == (queryList.length - 1)) {
                queryList.push(item.query)
              }
            }
          })
        }
      })

      queryList.forEach(query => {
        retDataSet.push(["Keyword", query.join(' & ')]);
        retDataSet.push(["Channel"]);
        retDataSet.push(["Rank"])
        let startIndex = retDataSet.length - 2;

        for (let j = 0; j < 9; j++) {
          retDataSet.push([j + 1])
          for (let i = 0; i < 50; i++) {
            retDataSet.push([""])
          }
        }



        data.reportData.filter(reportItem => arrayCompare(reportItem.query, query)).forEach((filteredItem, filteredItemIndex) => {
          retDataSet[startIndex].push(Channel_CODE_SET[filteredItem.channel], "", "", "");
          retDataSet[startIndex + 1].push("Word", "Count", "", "")

          for (let i = 0; i < 9; i++) {
            if (filteredItem.data[0].children.length > i) {
              retDataSet[startIndex + 2 + i + i * 50].push(filteredItem.data[0].children[i].name, filteredItem.data[0].children[i].value, "", "");  // WORD COUNT 

              for (let j = 0; j < 50; j++) {
                if (filteredItem.data[0].children[i].children.length > j) {
                  retDataSet[startIndex + 3 + j + i + i * 50].push("", "", filteredItem.data[0].children[i].children[j].name, filteredItem.data[0].children[i].children[j].value)
                }
                else {
                  retDataSet[startIndex + 3 + j + i + i * 50].push("", "", "", "");
                }
              }
            }
            else {
              retDataSet[startIndex + 2 + i + i * 50].push("", "", "", "");  // WORD COUNT 
              for (let j = 0; j < 50; j++) {
                retDataSet[startIndex + 3 + j + i + i * 50].push("", "", "", "");
              }
            }
          }
        })

        let deleteRows = [];
        for (let i = startIndex; i < retDataSet.length; i++) {
          retDataSet[i].some((string, index) => {
            if (string != "") {
              return true;
            }
            else {
              if (index == retDataSet[i].length - 1) {
                deleteRows.push(i);
              }
            }
          })
        }
        for (let i = deleteRows.length - 1; i >= 0; i--) {
          retDataSet.splice(deleteRows[i], 1);
        }
      })

      break;
    }
    case "relation": {
      let queryList = [];
      data.reportData.forEach(item => {
        if (queryList.length == 0) {
          queryList.push(item.query);
        }
        else {
          queryList.some((query, index) => {
            if (arrayCompare(item.query, query)) {
              return true;
            }
            else {
              if (index == (queryList.length - 1)) {
                queryList.push(item.query)
              }
            }
          })
        }
      })

      queryList.forEach(query => {
        retDataSet.push(["Keyword", query.join(' & ')]);
        retDataSet.push(["Channel"]);
        retDataSet.push(["Rank"])
        const startIndex = retDataSet.length - 2; //Channel

        for (let j = 0; j < data.options.words; j++) {
          retDataSet.push([j + 1]);
        }

        data.reportData.filter(reportItem => arrayCompare(reportItem.query, query)).forEach((filteredItem, filteredItemIndex) => {
          retDataSet[startIndex].push(Channel_CODE_SET[filteredItem.channel], "");
          retDataSet[startIndex + 1].push("Word", "Count");

          //data[0] => all data
          filteredItem.excelData[0].data.forEach((row, index) => {
            retDataSet[startIndex + 2 + index].push(row.text, row.value);
          })
        })
      })
      break;
    }
    case "positioningmap": {
      data.reportData.forEach(reportItem => {
        retDataSet.push(["Channel", Channel_CODE_SET[reportItem.channel]]);
        reportItem.data.forEach(subReportItem => {
          retDataSet.push(["Keyword", subReportItem.title]);
          retDataSet.push(["Positive", subReportItem.positive.value]);
          retDataSet.push(["Negative", subReportItem.negative.value]);
          retDataSet.push(["PSR", subReportItem.y]);
          retDataSet.push(["Volume", subReportItem.value])
        })
        retDataSet.push([""])
      })
      break;
    }

    default:
      break;
  }

  return retDataSet;
}

const setUsageExcelData = (data) => {
  let retDataSet = [['MONTHCODE', 'EMAIL', 'COUNT']];

  data.forEach(usageRow => {
    retDataSet.push([usageRow.monthcode, usageRow.email, usageRow.cnt])
  })

  return retDataSet;
}

const setTrendExcelData = (data) => {
  let retDataSet = [
    ["Report Type", "Trend"],
    ["StartDate", data.data[0].date],
    // ["EndDate", data.data[data.data.length - 1].date]
    // [""]
  ];

  if (data.data[data.data.length - 1].hasOwnProperty('end_date')) {
    retDataSet.push(["EndDate", data.data[data.data.length - 1].end_date])
    retDataSet.push([""])
  }
  else {
    retDataSet.push(["EndDate", data.data[data.data.length - 1].date])
    retDataSet.push([""])
  }

  switch (data.reportType) {
    case "volume": {
      data.query.forEach((queryItem, index) => {
        retDataSet.push(["Keyword", queryItem]);
        retDataSet.push(["Date", "PC", "MOBILE", "ALL"]);

        data.data.forEach((item) => {
          const pcKey = `pc${index}`;
          const moKey = `mo${index}`;
          const allKey = `all${index}`;

          if (item.hasOwnProperty('end_date')) {
            retDataSet.push([`${item.date} ~ ${item.end_date}`, item[pcKey], item[moKey], item[allKey]]);
          }
          else {
            retDataSet.push([item.date, item[pcKey], item[moKey], item[allKey]]);
          }
        })
        retDataSet.push([""])
      })

      break;
    }
    case "detail": {
      data.query.forEach((queryItem, index) => {
        retDataSet.push(["Keyword", queryItem]);
        // retDataSet.push(["Date", "PC", "MOBILE", "ALL"]);
        let excelColumn = ["Date"];

        data.genderage.forEach((gaItem, gaIndex) => {
          excelColumn.push(TREND_DETAIL_AGE_GENDER_SET[gaItem])
        })
        retDataSet.push(excelColumn);

        data.data.forEach((item) => {
          let gaValue = [];
          if (item.hasOwnProperty('end_date')) {
            gaValue.push(`${item.date} ~ ${item.end_date}`);
          }
          else {
            gaValue.push(item.date);
          }

          data.genderage.forEach((gaItem, gaIndex) => {
            const queryKey = `all${index}-${gaItem}`;
            gaValue.push(item[queryKey])
          })
          retDataSet.push(gaValue);
        })
        retDataSet.push([""])
      })

      break;
    }
    default:
      break;
  }

  return retDataSet;
}

const setTrendCustomExcelData = (data) => {
  let retDataSet = [
    ["Report Type", "Trend"],
    ["StartDate", data.data[0].date],
    // ["EndDate", data.data[data.data.length - 1].date],
    // [""]
  ];

  if (data.data[data.data.length - 1].hasOwnProperty('end_date')) {
    retDataSet.push(["EndDate", data.data[data.data.length - 1].end_date])
    retDataSet.push([""])
  }
  else {
    retDataSet.push(["EndDate", data.data[data.data.length - 1].date])
    retDataSet.push([""])
  }

  switch (data.reportType) {
    case "detail": {
      data.query.forEach((queryItem, index) => {
        // retDataSet.push(["Keyword", queryItem]);
        retDataSet.push(["키워드", "성별", "연령", "날짜", "검색량"]);
        data.data.forEach((item) => {
          data.genderage.forEach((gaItem) => {
            const queryKey = `all${index}-${gaItem}`;
            let itemDate = '';
            if (item.hasOwnProperty('end_date')) {
              itemDate = `${item.date} ~ ${item.end_date}`;
            }
            else {
              itemDate = item.date;
            }
            retDataSet.push([queryItem, TREND_DETAIL_CUSTOM_GENDER_SET[gaItem], TREND_DETAIL_CUSTOM_AGE_SET[gaItem], itemDate, item[queryKey]]);
          })
        })
        retDataSet.push([""])
      })

      break;
    }
    default:
      break;
  }

  return retDataSet;
}

const ExportExcel = (type, data, role) => {
  let today = new Date();
  const name = `${data.name}_${today.toLocaleDateString("ja-JP", { year: "numeric", day: "2-digit", month: "2-digit" }).replace(/(\d{4})(\d{2})(\d{2})/g, '$1-$2-$3')}`;

  switch (type) {
    case "usage": {
      const excelData = setUsageExcelData(data);
      const rt = 'Include'
      const ws = xlsx.utils.aoa_to_sheet(excelData);
      const wb = xlsx.utils.book_new();
      xlsx.utils.book_append_sheet(wb, ws, "Sheet1");

      return xlsx.writeFile(wb, `Buzzword_Usage_${data[0].monthcode}.xlsx`);
    }
    case "query-label": {
      const excelData = setQueryExcelData(data);
      const ws = xlsx.utils.json_to_sheet(excelData);
      const wb = xlsx.utils.book_new();
      xlsx.utils.book_append_sheet(wb, ws, "Sheet1");
      return xlsx.writeFile(wb, `My_Keyword_${today.toLocaleDateString("ja-JP", { year: "numeric", day: "2-digit", month: "2-digit" }).replace(/(\d{4})(\d{2})(\d{2})/g, '$1-$2-$3')}.xlsx`);
    }
    case "report-graph": {
      if (data.reportType === "buzzlist" || data.reportType === "channel_buzzlist") {
        const wb = xlsx.utils.book_new();
        data.reportData.forEach((item, index) => {
          const excelData = setBuzzlistExcelData(item, data.name, data.dateRange, data.reportType, data.subQueryType, role);
          const rt = 'Include';
          const ws = xlsx.utils.aoa_to_sheet(excelData);
          let sheetName = `${item.info.name.join(' & ')} (${Channel_CODE_SET[item.info.code]})`;

          if (sheetName.length > 25) {
            sheetName = sheetName.substr(0, 25) + "...";
          }

          const sheetNameFilter = ["\\", "/", "?", "*", "[", "]"];

          sheetName = replaceMultipleCharacters(sheetName, sheetNameFilter, "..");
          //sheetNameFilter 문자열을 ..로 치환함

          // xlsx.utils.book_append_sheet(wb, ws, `${item.info.name.join(' & ')} (${Channel_CODE_SET[item.info.code]})`);
          xlsx.utils.book_append_sheet(wb, ws, sheetName);
        })

        return xlsx.writeFile(wb, `${name}.xlsx`);
      }
      else {
        const excelData = setReportExcelData(data);
        const rt = 'Include'
        const ws = xlsx.utils.aoa_to_sheet(excelData);
        const wb = xlsx.utils.book_new();
        xlsx.utils.book_append_sheet(wb, ws, "Sheet1");

        return xlsx.writeFile(wb, `${name}.xlsx`);
      }
    }
    case "trend-graph": {
      const excelData = setTrendExcelData(data);
      const rt = 'Include'
      const ws = xlsx.utils.aoa_to_sheet(excelData);
      const wb = xlsx.utils.book_new();
      xlsx.utils.book_append_sheet(wb, ws, "Sheet1");

      return xlsx.writeFile(wb, `trend_${data.reportType}_${today.toLocaleDateString("ja-JP", { year: "numeric", day: "2-digit", month: "2-digit" }).replace(/(\d{4})(\d{2})(\d{2})/g, '$1-$2-$3')}.xlsx`);
    }
    case "trend-graph-custom": {
      const excelData = setTrendCustomExcelData(data);
      const rt = 'Include'
      const ws = xlsx.utils.aoa_to_sheet(excelData);
      const wb = xlsx.utils.book_new();
      xlsx.utils.book_append_sheet(wb, ws, "Sheet1");

      return xlsx.writeFile(wb, `trend_${data.reportType}_${today.toLocaleDateString("ja-JP", { year: "numeric", day: "2-digit", month: "2-digit" }).replace(/(\d{4})(\d{2})(\d{2})/g, '$1-$2-$3')}.xlsx`);
    }

    default:
      break;
  }
}


export default ExportExcel;